import { Separator } from '../../../../../primitives/separator';
import { Editor, EDITOR_CONTROLS } from '../../../../editor';
import { LabelWithoutRef } from '../../../../label/label-without-ref';

import { Alignment } from '../controls/alignment';
import { Spacing } from '../controls/spacing';
import { Typography } from '../controls/typography';

import type { TextEditorContentProps } from './types';

export type { TextEditorStyleUpdates } from './types';

export function TextEditorContent({
  alignment,
  backgroundColor,
  fontFamily,
  fontSize,
  fontWeight,
  paddingBottom,
  paddingLeft,
  paddingRight,
  paddingTop,
  margin,
  text,
  textColor,
  onStyleChange,
  onTextChange,
}: TextEditorContentProps) {
  return (
    <div className="grid gap-4">
      <div className="space-y-2">
        <p className="text-xs font-medium">Contenido</p>
        <div>
          <LabelWithoutRef className="text-xs font-medium text-muted-foreground">
            Texto
          </LabelWithoutRef>
          <Editor
            content={text}
            controls={[
              EDITOR_CONTROLS.toggleBold,
              EDITOR_CONTROLS.toggleItalic,
              EDITOR_CONTROLS.toggleStrike,
              EDITOR_CONTROLS.toggleUnderline,
              EDITOR_CONTROLS.buttonDivider,
              EDITOR_CONTROLS.toggleLink,
            ]}
            ext={{ mention: { items: ['variable'] } }}
            id="content-text"
            onChange={(content) => onTextChange(content.markdown)}
          />
        </div>
      </div>

      <Separator />

      <Typography
        backgroundColor={backgroundColor}
        fontFamily={fontFamily}
        fontSize={fontSize}
        fontWeight={fontWeight}
        isBackgroundColorVisible
        isFontFamilyVisible
        isFontSizeVisible
        isFontWeightVisible
        isTextColorVisible
        textColor={textColor}
        onBackgroundColorChange={(backgroundColor) => onStyleChange({ backgroundColor })}
        onFontFamilyChange={(fontFamily) => onStyleChange({ fontFamily })}
        onFontSizeChange={(fontSize) => onStyleChange({ fontSize })}
        onFontWeightChange={(fontWeight) => onStyleChange({ fontWeight })}
        onTextColorChange={(color) => onStyleChange({ color })}
      />

      <Separator />

      <Alignment
        isHorizontalAlignmentVisible
        horizontalAlignment={alignment}
        onHorizontalAlignmentChange={(textAlign) => onStyleChange({ textAlign })}
      />

      <Separator />

      <Spacing
        margin={margin}
        onChangeMargin={(margin) => onStyleChange({ margin })}
        paddingTop={paddingTop}
        paddingBottom={paddingBottom}
        paddingLeft={paddingLeft}
        paddingRight={paddingRight}
        isPaddingVisible
        onChangePaddingBottom={(bottom) => onStyleChange({ padding: { bottom } })}
        onChangePaddingLeft={(left) => onStyleChange({ padding: { left } })}
        onChangePaddingRight={(right) => onStyleChange({ padding: { right } })}
        onChangePaddingTop={(top) => onStyleChange({ padding: { top } })}
      />
    </div>
  );
}
